import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import store from '@/store'
import _ from "lodash";
import { szzy } from '@/common/index.js';
import "babel-polyfill";
import ElementUI from 'element-ui'
import Swiper from 'swiper';
import './common/components.js';
import * as echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.min.css';
import VueQuillEditor from '@/editor/config'
import {changeDurs, changeTime,screen} from '@/common/common.js'
import Tit from '@/components/small_title.vue'

Vue.component('Tit', Tit)
import noData from '@/components/nodatas.vue'
Vue.component('noData', noData)
Vue.prototype.$changeTime = changeTime
Vue.prototype.$changeDurs = changeDurs
Vue.prototype.$screen = screen
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.prototype.$swiper = Swiper
Vue.config.productionTip = false
Vue.prototype.$szzy= szzy
Vue.prototype.$VueQuillEditor = VueQuillEditor

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
